/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SalaryRangeAnalysisJobDetail = {
    companyJobId: number;
    jobTitle: string;
    jobCode: string;
    jobFamilyTitle: string | null;
    rangeId: number;
    min: number | null;
    mid: number | null;
    max: number | null;
    average: number;
    status: SalaryRangeAnalysisJobDetail.status;
    incumbentCount: number;
};

export namespace SalaryRangeAnalysisJobDetail {

    export enum status {
        BELOW = 'below',
        WITHIN = 'within',
        ABOVE = 'above',
    }


}

